import React, { useState, useRef, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  getAllFilterData,
} from "../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";

import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import DateTimePicker from "react-datetime-picker";
import "react-datetime-picker/dist/DateTimePicker.css";
import Switch from "@mui/material/Switch";
import moment from "moment/moment";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormLabel from "@mui/material/FormLabel";
import Select from "@mui/material/Select";
const CreateBouns = (props) => {
  const { onClose, editData, open, ...other } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [des, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [code, setCode] = useState("");
  const [playerCount, setPlayerCount] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [image, setImage] = useState("");
  const [link, setLink] = useState("");
  const [cutoffdate, setCutoffdate] = useState("");
  const [cutofftime, setCutofftime] = useState("");
  const [startdate, setStartdate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [sort, setSort] = useState("");
  const [starting, setStarting] = useState("");
  const [ending, setEnding] = useState("");
  const [startTiming, setStartTiming] = useState("");
  const [endTiming, setEndTiming] = useState("");
  const [type, setType] = useState("");
  const [amount, setAmount] = useState("");
  const [maxBonusAmount, setMaxBonusamount] = useState("");
  const [minDepositAmount, setMinDepositAmount] = useState("");
  const [depositType, setDepositType] = useState("");

  const [playerType, setPlayerType] = useState([]);
  const [playerStatus, setPlayerStatus] = useState([]);
  const [value, setValue] = useState("");
  const[userlist,setUserList] = useState(" ");
  const [customerIds, setCustomerIds] = useState('');

  //   max_amount. --- Maximum Bonus Amount
  // min_deposit -- minimum Deposit Amount

  const params = useParams();

  useEffect(() => {
    if (startdate || startTime) {
      setStarting(startdate.concat("", startTime));

      setStartTiming(
        moment(starting, "YYYY-MM-DDHH:mm").format("YYYY-MM-DDTHH:mm:ss")
      );
    }

    if (cutoffdate || cutofftime) {
      setEnding(cutoffdate.concat("", cutofftime));

      setEndTiming(
        moment(ending, "YYYY-MM-DDHH:mm").format("YYYY-MM-DDTHH:mm:ss")
      );
    }
  });  

  React.useEffect(() => {
    if (open) {
      if (Object.keys(editData).length === 0) {
        setTitle(editData?.title);
        setDescription(editData?.description);
        setType(editData?.type_bonus);
        setAmount(editData?.amount);
        setDepositType("");
        setIsActive(editData?.isActive || false);
        setValue(editData?.player_option);
        setUserList(editData?.user_list || "");
        setCutoffdate("");
        setCutofftime("");
        setStartdate("");
        setStartTime("");
      } else {
        setTitle(editData?.title);
        setDescription(editData?.description || "");
        setType(editData?.type_bonus || "");
        setAmount(editData?.amount);
        setIsActive(editData?.isActive || false);
        setUserList(editData?.user_list || "");
        setDepositType(editData?.customer_deposit || "");
        setCutoffdate(moment(editData?.endTime).format("YYYY-MM-DD"));
        setCutofftime(moment.utc(editData?.endTime).format("HH:mm"));
        setStartdate(moment(editData?.startTime).format("YYYY-MM-DD"));
        setStartTime(moment.utc(editData?.startTime).format("HH:mm"));
        setMinDepositAmount(editData?.min_deposit || "");
        setMaxBonusamount(editData?.max_amount || "");
        setValue(editData?.player_option)
      }
    }
  }, [editData, open]);

  const handleCancel = () => {
    onClose();
  };

  useEffect(() => {
    getPlayerTypes();
    getPlayerStatus();
  }, []);

  const getPlayerTypes = () => {
    let url = `${endPoints.api.playertypes}`;
    getAllData(url)
      .then((response) => {
        const { status, data, message } = response;

        if (status === "success") {
          setPlayerType(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getPlayerStatus = () => {
    let url = `${endPoints.api.playerStatus}`;
    getAllData(url)
      .then((response) => {
        const { status, data, message } = response;
        console.log("data", data);
        if (status === "success") {
          setPlayerStatus(data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };


  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();

    reader.onload = (e) => {
      const text = e.target.result;
      // Assuming the CSV contains only one column of customer IDs
      const idsArray = text.split('\n').map(row => row.trim());
      const user_ids = idsArray.join(',');
      setCustomerIds(user_ids);
    };

    reader.readAsText(file);
  };


  const handleOk = () => {
    if (title && des && type) {
      let url = editData?.id_bonus
        ? `${endPoints.api.UPDATE_BONUS}`
        : `${endPoints.api.CREATE_BONUS}`;
      //type_bonus = 1 for Percent and 2 for FIxed
      // "id_bonus": 0,
      //  fixed percentage
      //  let type_bonus = type == 'fixed'? '2' : '1'
      let payload = {
        title: title,
        description: des,
        amount: amount,
        type_bonus: type,
        startTime: startTiming,
        endTime: endTiming,
        isActive: isActive,
        max_amount: maxBonusAmount,
        min_deposit: minDepositAmount,
        customer_deposit: depositType,
        player_option: depositType == "4" ? value : depositType == "5" ? value : "",
        user_list:depositType == "6"?(editData?.id && customerIds ? customerIds  :  editData?.id && customerIds ==""?  editData.user_list : customerIds):"",
        // startdate:startdate,
        // starttime:startTime,
        // cutoffdate:cutoffdate,
        // cutofftime:cutofftime
      };

      if (editData?.id_bonus) {
        payload.id_bonus = editData.id_bonus;
      }
      setIsLoading(true);
      addData(url, payload)
        .then((response) => {
          setIsLoading(false);
          if (response.data.status === "success") {
            SuccesToast(response?.data?.message);
            // console.log("image",image);
            onClose();
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.error(error);
          ErrorToast(error);
        });
    } else {
      ErrorToast("all fields are required");
    }
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };
  return (
    <Dialog
      xl={{ "& .MuiDialog-paper": { width: "100%", maxHeight: 435 } }}
      maxWidth="sm"
      open={open}
      {...other}
    >
      <DialogTitle>Bonus Info </DialogTitle>

      <DialogContent dividers>
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Title"
            value={title}
            onChange={(event) => {
              setTitle(event.target.value);
            }}
          />
        </FormControl>

        {/* <FormControl style={{ width: "10%", marginTop: "20px" }}></FormControl> */}

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Description"
            value={des}
            onChange={(event) => {
              setDescription(event.target.value);
            }}
          />
        </FormControl>
        <FormControl>
          <FormLabel
            id="demo-row-radio-buttons-group-label"
            style={{ marginTop: "20px" }}
          >
            Deposit Type
          </FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
          >
            <FormControlLabel
              value="1"
              checked={depositType == "1" ? true : false}
              control={<Radio />}
              label="Customer First Deposit"
              onChange={() => {
                setDepositType("1");
              }}
            />
            <FormControlLabel
              value="2"
              checked={depositType == "2" ? true : false}
              control={<Radio />}
              label="All Customer Deposit"
              onChange={() => {
                setDepositType("2");
              }}
            />
            <FormControlLabel
              value="3"
              checked={depositType == "3" ? true : false}
              control={<Radio />}
              label="Refer A Friend"
              onChange={() => {
                setDepositType("3");
              }}
            />
            <FormControlLabel
              value="3"
              checked={depositType == "4" ? true : false}
              control={<Radio />}
              label="Player Type"
              onChange={() => {
                setDepositType("4");
              }}
            />
            <FormControlLabel
              value="3"
              checked={depositType == "5" ? true : false}
              control={<Radio />}
              label="Player Status"
              onChange={() => {
                setDepositType("5");
              }}
            />

             <FormControlLabel
              value="3"
              checked={depositType == "6" ? true : false}
              control={<Radio />}
              label="User List"
              onChange={() => {
                setDepositType("6");
              }}
            />

          </RadioGroup>
        </FormControl>

        {depositType == "4" && (
          <FormControl style={{ width: "100%" ,marginTop:'15px'}}>
            <InputLabel id="demo-simple-select-helper-label">
              Select Option
            </InputLabel>

            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={value}
              label="Secert Question"
              onChange={handleChange}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {playerType.map((option) => (
                <MenuItem value={option.id}>
                  {option.player_type}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        {depositType == "5" && (
          <FormControl style={{ width: "100%",marginTop:'15px' }}>
            <InputLabel id="demo-simple-select-helper-label">
              Select Option
            </InputLabel>

            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={value}
              label="Secert Question"
              onChange={handleChange}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {playerStatus.map((option) => (
                <MenuItem value={option.id}>
                  {option.player_status}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}

             {depositType == "6" && (
                // <label style={{marginTop:"5px"}}>Upload User List</label> 
                <Form.Control
                style={{marginBottom:"20px",width: "100%"}} 
                id="filled-required"
                variant="outlined"
                label="image"
                // value={image}
                name={userlist}
                type="file" 
                onChange={handleFileUpload} 
                accept=".csv"
                />
              )}

        <FormControl>
          <FormLabel
            id="demo-row-radio-buttons-group-label"
            style={{ marginTop: "20px" }}
          >
            Type
          </FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
          >
            <FormControlLabel
              value="1"
              checked={type == "1" ? true : false}
              control={<Radio />}
              label="Percentage of deposit"
              onChange={() => {
                setType("1");
              }}
            />
            <FormControlLabel
              value="2"
              checked={type == "2" ? true : false}
              control={<Radio />}
              label="Fixed amount"
              onChange={() => {
                setType("2");
              }}
            />
          </RadioGroup>
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "30px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Amount"
            value={amount}
            onChange={(event) => {
              setAmount(event.target.value);
            }}
          />
        </FormControl>
        <FormControl style={{ width: "100%", marginTop: "30px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Minimum Deposit Amount"
            value={minDepositAmount}
            onChange={(event) => {
              setMinDepositAmount(event.target.value);
            }}
          />
        </FormControl>
        <FormControl style={{ width: "100%", marginTop: "30px" }}>
          <TextField
            id="filled-required"
            variant="outlined"
            label="Maximum Bonus Amount"
            value={maxBonusAmount}
            onChange={(event) => {
              setMaxBonusamount(event.target.value);
            }}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <label>Start Date</label>
          <TextField
            id="filled-required"
            variant="outlined"
            placeholder="start date"
            type="date"
            value={startdate}
            onChange={(event) => {
              setStartdate(event.target.value);
            }}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <label>Start Time</label>
          {/* <InputLabel htmlFor="my-input">Start Date</InputLabel> */}
          <TextField
            id="filled-required"
            variant="outlined"
            // label="Start Time"
            placeholder="start date"
            type="time"
            value={startTime}
            onChange={(event) => {
              setStartTime(event.target.value);
            }}
          />
        </FormControl>

        {/* <FormControl style={{ width: "10%", marginTop: "20px" }}></FormControl> */}

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <label>End Date</label>
          <TextField
            id="filled-required"
            variant="outlined"
            // label="Cutoff Date"
            type="date"
            value={cutoffdate}
            onChange={(event) => {
              setCutoffdate(event.target.value);
            }}
          />
        </FormControl>

        <FormControl style={{ width: "100%", marginTop: "20px" }}>
          <label>End Time</label>
          <TextField
            id="filled-required"
            variant="outlined"
            // label="Cutoff Time"
            type="time"
            value={cutofftime}
            onChange={(event) => {
              setCutofftime(event.target.value);
            }}
          />
        </FormControl>

        <FormControlLabel
          control={
            <Switch
              name="active"
              value={isActive}
              onClick={() => {
                setIsActive(!isActive);
              }}
              defaultChecked={isActive}
            />
          }
          labelPlacement="start"
          label="Active"
        />
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Cancel
        </Button>
        <Button onClick={handleOk}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateBouns;
